import { cn } from '@/lib/utils';
import markPng from '@/assets/resqly-mark.png';

/**
 * RESQLY mark — transparent background, icon only.
 */
export default function ResqlyMark({ size = 36, className = '', alt = 'RESQLY' }) {
  return (
    <img
      src={markPng}
      alt={alt}
      className={cn('object-contain select-none', className)}
      style={{ width: size, height: size }}
      draggable={false}
    />
  );
}
